import { POST, GET } from '@/utils/request'
import Api from './url'

export interface ChatParams {
  token?: string
  query: string
  conversationId?: string
}

export const queryArticlesByPlatformId = async (params: any = {}) => {
  return await GET({
    url: Api.queryArticlesByPlatformId,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}

export const conversationFeedback = async (data: { conversationId: string; feedbackTag: string }) => {
  return await POST({ url: Api.conversation, data, showError: false })
}

export const endConversation = async (data: { conversationId: string }) => {
  return await POST({ url: Api.end, data, showError: false })
}
export const getGroupId = async (params: any = {}) => {
  return await GET({ url: Api.getGroupId, params, showError: false, showHttpError: false, showStatusError: false })
}
export const toAiChat = async (data: any = {}) => {
  return await POST({ url: Api.aiChat, data, showError: false, showHttpError: false, showStatusError: false })
}
// 创建工单时机
export const toCondition = async (params: any = {}) => {
  return await GET({ url: Api.toCondition, params, showError: false, showHttpError: false, showStatusError: false })
}
// 获取缓存时间 天为单位
export const getCacheDur = async (params: any = {}) => {
  return await GET({ url: Api.getCacheDur, params, showError: false, showHttpError: false, showStatusError: false })
}
export const citySwitch = async (params: object) => {
  return await GET({
    url: Api.citySwitch,
    params,
    showError: false
  })
}

export const getHotLine = async () => {
  return await GET({ url: Api.getHotLine, showError: false })
}

export const getWelcomeMessages = async (data: any = {}) => {
  return await POST({ url: Api.welcome, data, showError: false, showHttpError: false, showStatusError: false })
}

export interface UploadLogisticsInfoParams {
  orderNo: string
  logisticsCompany: string
  logisticsNo: string
  freightVouchers?: string[]
  ticketEquipmentId?: string
}

export const uploadLogisticsInfo = async (data: UploadLogisticsInfoParams) => {
  // 不再吞错,让调用方能根据 HTTP 状态码区分 500 等服务端错误
  return await POST({ url: Api.uploadLogisticsInfo, data, showError: false, showHttpError: false, showStatusError: false })
}

export interface ApplyEquipAfterSaleParams {
  orderNo: string
  aftersaleType: number // 0退货 / 1换货 / 2拒收 / 3补发
  courierId: number
  reasonType: number // 0尺码不合适 / 1装错了 / 2质量问题 / 3商品发错 / 4快递丢失 / 5装备漏发 / 6未及时领取导致退回
  exchangeType?: number // 换货类型：0服装类 / 1装备类
  changeSize?: string
  qualityPics?: string[]
}

export const applyEquipAfterSale = async (data: ApplyEquipAfterSaleParams) => {
  try {
    return await POST({ url: Api.applyEquipAfterSale, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    // 屏蔽 request.ts 的"网络不给力"通用 toast,由调用方自己处理错误信息
    return null
  }
}

// 换货尺码配置
export interface ExchangeSizeConfigItem {
  code: number // 尺码编码
  size: string // 尺码（M/L/XL/2XL/3XL/特体/特体2/特体3）
  height: string // 身高范围，如 155-160cm
  weight: string // 体重范围，如 80-100斤
}

export const getExchangeSizeConfig = async (params: any = {}) => {
  return await GET({ url: Api.exchangeSizeConfig, params, showError: false, showHttpError: false, showStatusError: false })
}

// 权益恢复申请
export interface RightsMaterial {
  materialType: number
  materialTypeDesc: string
  urls: string[]
}

export interface SubmitRightsApplyParams {
  courierId: number
  rightsType: number
  applyType: number
  applyReason?: string
  restStartTime?: string
  restEndTime?: string
  orderNumber?: string
  materials?: RightsMaterial[]
  chatId: string
}

export const submitRightsApply = async (data: SubmitRightsApplyParams): Promise<any> => {
  try {
    return await POST({ url: Api.submitRightsApply, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}

// 重新提交权益恢复申请
export interface ResubmitRightsApplyParams {
  auditId: number
  courierId: number
  applyReason?: string
  restStartTime?: string
  restEndTime?: string
  materials?: RightsMaterial[]
}

export const resubmitRightsApply = async (data: ResubmitRightsApplyParams): Promise<any> => {
  try {
    return await POST({ url: Api.resubmitRightsApply, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}

// 选择配送订单-分页查询
export interface PagingOrdersParams {
  businessTab: number // 业务 Tab：1帮取送、2其他（帮买/闪帮/往返/松鼠/无人机）
  status: number // 订单状态 Tab：0全部、1进行中、2已完成、3已取消、4已转单
  pageNo: number // 页码，从1开始
  pageSize: number // 固定 10
}

export interface PagingOrderTask {
  infoId: number | null
  status: number | null
  statusDesc: string | null
  fromAddress: string | null
  toAddress: string | null
}

export interface PagingOrderItem {
  orderId: number
  orderNumber: string
  status: number | null
  statusDesc: string | null
  orderType: number | null
  orderTypeDesc?: string | null // 订单类型描述（如：帮我买单）
  appointTypeDesc: string | null // 时效类型：实时 / 预约
  fromAddress: string | null
  toAddress: string | null
  grabTime: number | null // 接单时间，Unix 毫秒
  finishTime: number | null // 完成时间，Unix 毫秒
  abortTime: number | null // 取消时间，Unix 毫秒
  turnFlag: boolean | null // 是否已转单
  turnTime: number | null // 转单时间，Unix 毫秒
  tasks: PagingOrderTask[] | null
}

export const pagingOrders = async (data: PagingOrdersParams): Promise<any> => {
  try {
    return await POST({ url: Api.pagingOrders, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}

// 意图推荐
export interface RecommendIntentsParams {
  orderNumber?: string // 已选配送订单号；省略或为空时仅推荐非订单意图
  cityId?: number // 城市 ID；省略时按需查询当前闪送员所在城市
  longitude?: number // 经度；与 latitude 同时提供时参与位置判断
  latitude?: number // 纬度
}

export interface RecommendIntentItem {
  themeId?: number | null // 主题ID：二级分组时为二级主题ID，三级直展时为三级主题ID；高频知识库意图为 null
  themeName?: string | null // 主题名称
  themeIcon?: string | null // 主题图标地址
  aiScene?: string | null // AI 场景编码，用于后续场景路由
  problem?: string | null // 问题名称（三级直展/高频意图时有值，二级分组时为空）
  problemDesc?: string | null // 问题描述（三级直展/高频意图时有值，二级分组时为空）
  canClaim?: boolean | null // 是否可理赔（三级直展时有值，二级分组时为空）
  knowledgeId?: string | null // 知识库ID（高频知识库意图直展时有值，跳转知识库）
  children?: RecommendIntentItem[] | null // 三级子意图列表（非空时表示当前为二级分组）
}

// recommendIntents 接口出参 data：无匹配时 problems 为空数组，失败时为 null
export interface RecommendIntentsData {
  displayCount?: number | null // 展示条数（默认6）：后端不截断返回全部匹配意图，由前端控制顶层条目与每组三级意图的展示条数
  problems?: RecommendIntentItem[] | null // 意图推荐列表（二级分组或三级直展）
}

export const recommendIntents = async (data: RecommendIntentsParams): Promise<any> => {
  try {
    return await POST({ url: Api.recommendIntents, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}

// 订单信息查询/推荐（订单入口传所选订单号，非订单入口省略时自动推荐订单）
export interface GetOrderInfoParams {
  orderNumber?: string // 订单号；省略、传空字符串或 null 时自动推荐订单
}

// 关联的处理中二线投诉工单
export interface ProcessingTicket {
  ticketId: number | null // 工单 ID
  ticketNumber: string | null // 工单编号
  themeId: number | null // 工单主题 ID
  themeName: string | null // 工单主题名称
  type?: number | null // 工单类型：1-退换货进度查询 2-外呼记录查询 3-查看审核记录
  typeDesc?: string | null // 工单类型描述；type 为 null 时为空
  problem: string | null // 投诉问题名称
  problemDesc: string | null // 投诉问题描述
  answerAging: number | null // 应回复时效，绝对截止时间，Unix 毫秒
  innerCode: string | null // 客服公共响应内部码，成功时为 success
}

// getOrderInfo 出参 data
export interface OrderInfoData {
  order: PagingOrderItem | null // 指定或推荐的订单卡片；无可推荐订单时为空
  hasProcessingTicket: boolean // 所选订单是否存在处理中二线投诉工单
  processingTicket: ProcessingTicket | null // 关联的处理中二线投诉工单
}

export const getOrderInfo = async (data: GetOrderInfoParams): Promise<any> => {
  try {
    return await POST({ url: Api.getOrderInfo, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}

// 处理中二线投诉工单查询（订单入口传所选订单号，非订单入口省略）
export interface GetProcessingTicketParams {
  orderNumber?: string // 订单号；省略、传空字符串或 null 时不按订单过滤
}

// getProcessingTicket 出参 data
export interface ProcessingTicketData {
  hasProcessingTicket: boolean // 是否存在处理中二线投诉工单
  processingTicket: ProcessingTicket | null // 处理中二线投诉工单；不存在时为空
}

export const getProcessingTicket = async (data: GetProcessingTicketParams): Promise<any> => {
  try {
    return await POST({ url: Api.getProcessingTicket, data, showError: false, showHttpError: false, showStatusError: false })
  } catch (e) {
    return null
  }
}
// return await new Promise((resolve) => {
//   setTimeout(() => {
//     resolve({
//       data: {
//         welcome: '您好师傅，我是智能客服小闪，有问题找小闪，请用一句话描述您的问题',
//         problem: '师傅,看到您已进入就位圈，是遇到无法拿到收件码的问题吗？请选择问题或描述您的问题：',
//         aiFlag: true, // 是否匹配到AI场景
//         more: true, // 是否展示更多
//         // 展示的卡片
//         problems: [{
//           problem: '已拿到物品无法获取收件码已拿到物品无法获取收件码'
//         }, {
//           problem: '联系不到寄件人'
//         }]
//       }
//       //   [
//       //   {
//       //     id: 'welcome-1',
//       //     type: 'text',
//       //     content: 'Hi，我是您的专属闪送智能助手~',
//       //     sender: 'agent',
//       //     timestamp: Date.now()
//       //   },
//       //   {
//       //     id: 'welcome-2',
//       //     type: 'text',
//       //     content: '请问您是遇到了什么问题呢？',
//       //     sender: 'agent',
//       //     timestamp: Date.now()
//       //   },
//       //   {
//       //     id: 'welcome-3',
//       //     type: 'action_card',
//       //     content: '遇到问题了？',
//       //     actions: [
//       //       { text: '马上升级', actionType: 'upgrade' },
//       //       { text: '联系用户', actionType: 'contact_user' }
//       //     ],
//       //     sender: 'agent',
//       //     timestamp: Date.now()
//       //   }
//       // ]
//     })
//   }, 500)
// })
// }
